import { Navigate, Outlet } from 'react-router-dom';

import { useTokens } from '../hooks/useTokens';

export const AuthLayout = () => {
  const { tokens } = useTokens();

  if (tokens) {
    return <Navigate to="/" replace={true} />;
  }

  return <Outlet />;
};
